import React from "react";
import { motion } from "framer-motion";

const Services = () => {
  const framework = [
    {
      icon: "🎼",
      step: "CREATE",
      title: "Music Creation",
      features: [
        "Melody composing (even without instruments)",
        "Lyrics, emotion & song structure",
        "Turning ideas into complete songs"
      ]
    },
    {
      icon: "🎧",
      step: "PRODUCE",
      title: "Music Production",
      features: [
        "Home studio & DAW clarity",
        "Arrangement, sound selection & vocals",
        "Professional production workflows"
      ]
    },
    {
      icon: "🚀",
      step: "LAUNCH",
      title: "Music Launch",
      features: [
        "Music distribution & branding",
        "Reels, content & audience growth",
        "First income from original music"
      ]
    }
  ];

  return (
    <section className="py-20 px-6 bg-gradient-to-br from-purple-50 to-blue-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            My 3-Step Signature Framework
          </h2>
          <div className="w-24 h-1 bg-purple-600 mx-auto mb-6"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {framework.map((item, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              whileHover={{ scale: 1.03, y: -5 }}
              className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all"
            >
              <div className="text-6xl mb-4 text-center">{item.icon}</div>
              <h3 className="text-2xl font-bold text-purple-900 mb-2 text-center">
                {item.step}
              </h3>
              <p className="text-lg font-semibold text-gray-700 mb-4 text-center">{item.title}</p>
              <ul className="space-y-3">
                {item.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start text-gray-700">
                    <span className="text-purple-600 mr-2 font-bold">✓</span>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center bg-purple-900 text-white p-8 rounded-xl"
        >
          <p className="text-xl md:text-2xl font-semibold">
            This framework helps you release your first original song in 90 days — with clarity and confidence.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Services;
